import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { StoreComponent } from './store/store.component';
import { RefreshComponent } from './refresh/refresh.component';
import { PageNotFoundComponent } from '../core/page-not-found/page-not-found.component';
import { SalesComponent } from './sales/sales.component';
import { PublicStoreComponent } from './public-store/public-store.component';
import { AuthGuard } from '@auth0/auth0-angular';

export const routes: Routes = [
  {
    path: '',
    component: StoreComponent,
    title: 'Ma Boutique',
    canActivate: [AuthGuard],
  },
  { path: 'refresh', component: RefreshComponent, canActivate: [AuthGuard] },
  { path: 'sales', component: SalesComponent, title: 'Mes Ventes' },
  { path: ':id', component: PublicStoreComponent, data: { revalidate: 900 } },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StoreRoutingModule {}
